import { Provider as ReduxProvider } from 'react-redux';
import { store } from './store';
import { ErrorBoundary, NotificationHost } from '@/components/feedback';
import { SessionBootstrap } from '@/slices/auth';

/**
 * Props:
 *   children  the app tree
 */
export const Providers = ({ children }) => {
  return (
    <ErrorBoundary>
      <ReduxProvider store={store}>
        <SessionBootstrap>{children}</SessionBootstrap>
        <NotificationHost />
      </ReduxProvider>
    </ErrorBoundary>
  );
};
